import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/basketball-talent-pool/篮球国家队人才库.png'
import _imports_1 from '../../../assets/basketball-talent-pool/球员人才库.png'
import _imports_2 from '../assets/五人男篮.png'
import _imports_3 from '../assets/五人女篮.png'
import _imports_4 from '../assets/三人男篮.png'
import _imports_5 from '../assets/三人女篮.png'
import _imports_6 from '../assets/u23三人男篮初选.png'
import _imports_7 from '../assets/u23三人女篮初选.png'
import _imports_8 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-3b3f9371"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cover" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"logo\" data-v-3b3f9371><div class=\"txt\" data-v-3b3f9371><img src=\"" + _imports_0 + "\" data-v-3b3f9371></div></div><div class=\"player-talents\" data-v-3b3f9371><img src=\"" + _imports_1 + "\" alt=\"\" data-v-3b3f9371></div><p class=\"name-sort\" data-v-3b3f9371><span data-v-3b3f9371>名单将随赛事进展进行动态展示</span></p>", 3)
const _hoisted_6 = {
  class: "player-talent",
  style: {"margin-top":"0vw"}
}
const _hoisted_7 = { class: "player-talent" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"font\" data-v-3b3f9371><span data-v-3b3f9371>更新时间：2024/02/06</span></div><div class=\"footer\" data-v-3b3f9371><div class=\"genjian-logo\" data-v-3b3f9371><img src=\"" + _imports_8 + "\" alt=\"\" data-v-3b3f9371></div><span class=\"service-txt\" data-v-3b3f9371>中国篮协技战术服务平台</span></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("img", {
          src: _imports_2,
          alt: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showMessage('man_5')))
        }),
        _createElementVNode("img", {
          src: _imports_3,
          alt: "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showMessage('woman_5')))
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("img", {
          src: _imports_4,
          alt: "",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showThreeMessage('man_3')))
        }),
        _createElementVNode("img", {
          src: _imports_5,
          alt: "",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showThreeMessage('woman_3')))
        }),
        _createElementVNode("img", {
          src: _imports_6,
          alt: "",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showThreeMessage('u23_man_3')))
        }),
        _createElementVNode("img", {
          src: _imports_7,
          alt: "",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showThreeMessage('u23_woman_3')))
        })
      ]),
      _hoisted_8
    ])
  ]))
}